import LOGO from "../../2025_mens_b/images/potros.png";

export const Team__Potras = {
  name: "Potras",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#c37b00",
  teamJerseyColor: "#31A0BC",

  // Stats
  gamesWon: 0,
  gamesLost: 4,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 26 + 34 + 31 + 37,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 12 + 15 + 25 + 16,
    },
  ],
};
